import React from 'react';
import { Container } from './styles';

// import InstaGrid from '../InstaFeed';

export default function Instagram() {
  return (
    <>
      <div className="main-container short">
        <Container>
          <div className="title">
            <h2>
              Siga nosso Insta:{' '}
              <span>
                <br />
                @GrupoSaberOficial
              </span>
            </h2>
          </div>
          <div class="elfsight-app-b8e0521f-809b-4c4d-8f0c-524a90e7ba26"></div>
        </Container>
      </div>
    </>
  );
}
